// lucide icons
import {
  LayoutDashboard,
  Receipt,
  ChartPie,
  FileChartColumnIncreasing,
  Boxes,
  Users,
  Truck,
  Wallet,
  ChartLine,
  FileText,
  PackageOpen
} from 'lucide-react';

// icons
const icons = {
  LayoutDashboard,
  Boxes,
  Users,
  Truck,
  Wallet,
  FileText,
  PackageOpen,
  ChartLine,
  FileChartColumnIncreasing,
  Receipt,
  ChartPie
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Main Menu',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard/default',
      icon: icons.LayoutDashboard,
      breadcrumbs: false
    },
    {
      id: 'customer',
      title: 'Customer',
      type: 'item',
      url: '/customer',
      icon: icons.Users,
      breadcrumbs: false
    },
    {
      id: 'stock',
      title: 'Stock',
      type: 'collapse',
      icon: icons.Boxes,
      breadcrumbs: false,
      children: [
        {
          id: 'stock-in',
          title: 'Stock In',
          type: 'item',
          url: '/stock-in',
          icon: icons.PackageOpen,
          breadcrumbs: false
        },
        {
          id: 'stock-out',
          title: 'Stock Out',
          type: 'item',
          url: '/stock-out',
          icon: icons.Truck,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'petty-cash',
      title: 'Petty Cash',
      type: 'item',
      url: '/petty-cash',
      icon: icons.Wallet,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: 'Reports',
      type: 'collapse',
      icon: icons.FileChartColumnIncreasing,
      breadcrumbs: false,
      children: [
        {
          id: 'duties-taxes-report',
          title: 'Duties & Taxes',
          type: 'item',
          url: '/duties-taxes',
          icon: icons.Receipt,
          breadcrumbs: false
        },
        {
          id: 'monthly-invoices-report',
          title: 'Monthly Invoices',
          type: 'item',
          url: '/monthly-invoices',
          icon: icons.ChartPie,
          breadcrumbs: false
        },
        {
          id: 'monthly-statement-report',
          title: 'Monthly Statement',
          type: 'item',
          url: '/monthly-statement',
          icon: icons.ChartLine,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default dashboard;
